import { filter, get, includes, size } from "lodash"
import { createSelector } from "reselect"

const getResources = state => get(state, "global.data.resources.data.resources")
const getAccountPartner = (state) => get(state, "global.data.accountPartner.data")

// Since applications can only have access to PORTFOLIOS and SWAPS, quick hack for now, later it will
// need to have more code to allow selecting the right resource types
export const getAllowedResources = createSelector(
  [getResources],
  (resources) => filter(resources, r => includes(["PORTFOLIO", "SWAP"], r.type)),
)

export const getPermissions = (state) => get(state, "global.data.applicationPermissions.data.application.resourcePermissions")

// The slot still holds the previous application while the next one loads; the query id carries the
// route's alias.
export const getCurrentApplication = (state, props) => (
  get(state, "global.data.application.id") === `application-${get(props, "params.app")}`
    ? get(state, "global.data.application.data.application")
    : null
)

const sharedByType = (permissions, resourceType) => size(filter(permissions, p => p.type === resourceType))

export const getResourceLimits = createSelector(
  [getPermissions, getAccountPartner],
  (permissions, accountPartner) => ({
    portfolios: {
      shared: sharedByType(permissions, "PORTFOLIO"),
      limit: accountPartner.portfolioLimit,
    },
    baskets: {
      shared: sharedByType(permissions, "SWAP"),
      limit: accountPartner.basketLimit,
    },
  }),
)
